var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-layout"},[_c('junket-header'),_c('junket-nav'),_c('junket-main'),_c('junket-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }